import { DELIMITER } from 'app/shared/constants/AnalyticsDelimiterConstants';

const WILL_GET_CUSTOM_DATA = true;

const CATEGORY = `FindTenants${DELIMITER}InterestedRenters`;

const LABEL = {
    CLICK: 'Click',
    OUTBOUND_CLICK: 'OutboundClick',
    SUBMIT: 'Submit',
};

const GA_PREFIX = {
    VIEW_INDIVIDUAL_APPLICATION: 'ViewIndividualApplication',
};

const GA_EVENTS = {
    NEW_INQUIRIES_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        action: 'ViewNewInquiries',
        value: WILL_GET_CUSTOM_DATA,
    },
    UN_REPLIED_INQUIRIES_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        action: 'ViewUnrepliedInquiries',
        value: WILL_GET_CUSTOM_DATA,
    },
    TOTAL_INQUIRIES_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        action: 'ViewTotalInquiries',
        value: WILL_GET_CUSTOM_DATA,
    },
    ENABLES_APPLICATIONS_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        action: 'EnableApplications',
    },
    INVITE_TO_APPLY_EMPTY_STATE_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        action: `InviteToApplyClick${DELIMITER}EmptyState`,
    },
    INVITE_TO_APPLY_HAS_APPLICATIONS_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        action: `InviteToApplyClick${DELIMITER}HasApplications`,
    },
    INVITE_TO_APPLY_SEND_INVITATION_SUBMIT: {
        category: CATEGORY,
        label: LABEL.SUBMIT,
        action: `InviteToApply${DELIMITER}SendInvitation`,
    },
    LEARN_MORE_APPLICATIONS_EMPTY_STATE_CLICK: {
        category: CATEGORY,
        label: LABEL.OUTBOUND_CLICK,
        action: `LearnMore${DELIMITER}EmptyState`,
    },
    VIEW_APPLICATION_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        // ViewIndividualApplication-[application_status]
        action: WILL_GET_CUSTOM_DATA,
    },
    VIEW_ALL_APPLICATIONS_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        action: `ViewAllApplications${DELIMITER}TextLink`,
        value: WILL_GET_CUSTOM_DATA,
    },
    VIEW_ALL_APPLICATIONS_OVERFLOW_TILE_CLICK: {
        category: CATEGORY,
        label: LABEL.CLICK,
        action: `ViewAllApplications${DELIMITER}OverflowTile`,
        value: WILL_GET_CUSTOM_DATA,
    },
};

export {
    GA_EVENTS,
    GA_PREFIX,
};
